module.exports = __webpack_public_path__ + "static/media/general-button.5a3c6163.svg";